import { z } from 'zod';
import { oneOf, str } from '../../navigation/searchParams';

/** The voice list filters, the expanded row, and the voice editor. */
export const voiceConfigSearch = z.object({
  agent: str,
  provider: str,
  expanded: str,
  modal: oneOf(['create-voice', 'edit-voice']),
  id: str,
  mtab: str,
});
